import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';
import Btn from '../../atoms/btn';
import DsLabel from '../../atoms/label';
import DsLabelError from '../../atoms/label/labelError';
import DsLabelWarning from '../../atoms/label/labelWarning';

const renderCancellation = ({
  booking, currency, chain, context,
}) => {
  const isCancelled = booking.status === 'CANC' || booking.status === 'REV';
  const isCancellable = booking.can_cancel && chain !== 'PALMAIARESORTS';
  const hasCancellationFee = booking.cancellation_fee > 0;
  if (isCancelled) {
    return (
            <DsLabelError>
              {context.t('This booking is already cancelled')}
            </DsLabelError>
    );
  }
  if (!isCancellable) {
    return (
            <DsLabelError>
              {context.t('This booking can not be cancelled')}
            </DsLabelError>
    );
  }
  if (hasCancellationFee) {
    return (
            <DsLabelWarning>
              {context.t('Cancellation costs')}
              <span className="ml-2 can-cancel">
                {formatCurrency(
                  booking.cancellation_fee,
                  currency || booking.currency,
                )}
              </span>
            </DsLabelWarning>
    );
  }
  return (
          <DsLabel icon="check" iconClassName="text-status-green">
            {context.t('Cancellation costs')}
            <span className="ml-2 can-cancel">{context.t('Free cancellation')}</span>
          </DsLabel>
  );
};

const CardCancellation = (
  {
    className, booking, onClick, chain, currency,
  },
  context,
) => {
  const isCancellable = booking.can_cancel && chain !== 'PALMAIARESORTS';
  return (
          <div className={className}>
            <span className="text-lg text-primary-700">
              {renderCancellation({
                booking,
                currency,
                context,
                chain,
              })}
            </span>
            <div className="flex -mx-2">
              {/* eslint-disable react/no-danger */}
              <div
                      className="mx-2"
                      dangerouslySetInnerHTML={{ __html: booking.cancellation_txt }}
              />
              {/* eslint-enable react/no-danger */}
              {isCancellable && (
                      <Btn
                              variant="cancel"
                              onClick={onClick}
                              className="mt-auto whitespace-nowrap mx-2"
                      >
                        {context.t('Cancel your reservation')}
                      </Btn>
              )}
            </div>
          </div>
  );
};
CardCancellation.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CardCancellation;
